import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import flyInLeftGif from '../../../assets/images/transitions/flyInLeft.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_OUT_EDGE_LEFT = 'easeOutEdgeLeft';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeOutEdgeLeftPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_OUT_EDGE_LEFT,

  // A human friendly name for the preset.
  humanName: 'Ease Out to Edge Left',

  // A preview of the transition.
  gif: flyInLeftGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        end: 'end.0',
        start: 'end.-1000'
      },
      easing: EASINGS.easeInPower3,
      values: [
        'position.left',
        'off.left'
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_OUT_EDGE_LEFT,
    options: {},
  },
};

easeOutEdgeLeftPresetDetails.template.options = lodash.cloneDeep(easeOutEdgeLeftPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_OUT_EDGE_LEFT;

// This defines the value of the presets object.
export default easeOutEdgeLeftPresetDetails;
